import type { MailBackupUsage } from "../../api/types";

// 系統備份的用量文字。KB / MB 不留小數,GB 兩位小數。

export function formatBackupSize(bytes: number): string {
  const n = Math.max(0, bytes);
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} KB`;
  if (n < 1024 ** 3) return `${Math.round(n / 1024 / 1024)} MB`;
  return `${(n / 1024 ** 3).toFixed(2)} GB`;
}

export const formatCount = (n: number): string => n.toLocaleString("en-US");

/** 「1.23 GB · 4,321 封」 */
export const usageLine = (u: Pick<MailBackupUsage, "total_bytes" | "total_count">): string =>
  `${formatBackupSize(u.total_bytes)} · ${formatCount(u.total_count)} 封`;

/** 台北的今天往前推(年 / 月),回 `YYYY-MM-DD`。 */
export function shiftTaipeiDate(now: Date, back: { years?: number; months?: number }): string {
  const ymd = new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Taipei", year: "numeric", month: "2-digit", day: "2-digit" })
    .format(now)
    .split("-")
    .map(Number);
  const total = ymd[0] * 12 + (ymd[1] - 1) - (back.years ?? 0) * 12 - (back.months ?? 0);
  const year = Math.floor(total / 12);
  const month = (total % 12) + 1;
  // 月底往前推到沒有那一天的月份(3/31 → 2/28):取該月最後一天
  const last = new Date(Date.UTC(year, month, 0)).getUTCDate();
  const day = Math.min(ymd[2], last);
  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}
